import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import DespatchParticularReport from '../../common/components/DespatchParticularReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchParticularsReceptacleDetailsSelectors';

export function DespatchParticularsReceptacleDetailsContainer(props) {
  return (
    <DespatchParticularReport
      reportId={ReportDefinitions.DESPATCH_PARTICULARS_RECEPTACLE_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state, props) {
  return {
    data: getData(state, props),
    columns: getColumns(state, props),
    generatedDateTime: getGeneratedOnDateTime(state, props),
    isLoading: getIsLoading(state, props),
  };
}

DespatchParticularsReceptacleDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(DespatchParticularsReceptacleDetailsContainer);

